export default {
    APPEND_TO_LIST: 'APPEND_TO_LIST',
    SET_LIST: 'SET_LIST',
    CLEAR_LIST: 'CLEAR_LIST',
    SET_LIST_FILTER: 'SET_LIST_FILTER',
    CLEAR_LIST_FILTER: 'CLEAR_LIST_FILTER',
    SET_LIST_SORT: 'SET_LIST_SORT',
    CLEAR_LIST_SORT: 'CLEAR_LIST_SORT',
    CLEAR_TOTALS: 'CLEAR_TOTALS',
    SET_DATA: 'SET_DATA',
    CLEAR_DATA: 'CLEAR_DATA',
    SET_DETAIL: 'SET_DETAIL',
    SET_LOADING: 'SET_LOADING',
    INCREMENT_LOADINGS_IN_PROGRESS: 'INCREMENT_LOADINGS_IN_PROGRESS',
    DECREMENT_LOADINGS_IN_PROGRESS: 'DECREMENT_LOADINGS_IN_PROGRESS',
    SET_TOTALS: 'SET_TOTAL',
    SET_TOTAL_COUNT: 'SET_TOTAL_COUNT',
    SET_REFRESH: 'SET_REFRESH',
    SET_ALL_ITEMS_LOADED: 'SET_ALL_ITEMS_LOADED',
    CREATE_ITEM: 'CREATE_ITEM',
    CREATE_RAW_ITEM: 'CREATE_RAW_ITEM',
    DELETE_ITEM: 'DELETE_ITEM',
    UPDATE_ITEM: 'UPDATE_ITEM',
    UPDATE_FILTERS: 'UPDATE_FILTERS',
    CREATE_OR_UPDATE_ITEM: 'CREATE_OR_UPDATE_ITEM',
    CLEAR_DETAILS_DATA: 'CLEAR_DETAILS_DATA',
    SET_SELECTED: 'SET_SELECTED',

    SELECT_ITEM: 'SELECT_ITEM',
    DESELECT_ITEM: 'SELECT_ITEM',
    TOGGLE_SELECT_ITEM: 'TOGGLE_SELECT_ITEM',
    SELECT_ITEMS: 'SELECT_ITEMS',
    DESELECT_ITEMS: 'DESELECT_ITEMS',
    SELECT_ALL_ITEMS: 'SELECT_ALL_ITEMS',
    DESELECT_ALL_ITEMS: 'DESELECT_ALL_ITEMS',
};
